export default __webpack_public_path__ + "static/media/maker1.9d2eb8d9.png";